import { Component } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'td-wb-integration-error',
  templateUrl: './integration-error.component.html',
  imports: [TranslateDirective]
})
export class IntegrationErrorComponent {
}
